import React from "react";

class UploadForm extends React.Component {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
    }

    onChange(e) {
        this.props.onFileSelected(e.target.files[0]);
        //        this.setState({file:e.target.files[0]})
    }

    render() {
        return (
            <form>
                <h1>{this.props.title}</h1>
                <input type="file" onChange={this.onChange} />
            </form>
        );
    }
}

export default UploadForm;
